import React, { useEffect, useState } from "react";
import { api, getToken, API } from "@/lib/api";

/**
 * Inline image renderer for chat messages with kind=image.
 * Fetches with Bearer token and displays as a click-to-expand thumbnail.
 */
export default function MessageImage({ path }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [errored, setErrored] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!path) return;
    let cancelled = false;
    let url = null;
    const token = getToken();
    fetch(`${API}/files/${path}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
      .then(async (r) => {
        if (!r.ok) throw new Error("image fetch failed");
        const blob = await r.blob();
        if (cancelled) return;
        url = URL.createObjectURL(blob);
        setBlobUrl(url);
      })
      .catch(() => setErrored(true));
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);

  if (errored) {
    return <div className="text-xs text-rose-300">Image failed to load</div>;
  }
  if (!blobUrl) {
    return (
      <div className="w-48 h-48 rounded-xl bg-white/5 border border-white/10 animate-pulse" />
    );
  }
  return (
    <>
      <button
        type="button"
        onClick={() => setExpanded(true)}
        className="block rounded-xl overflow-hidden border border-white/10 max-w-[260px] sm:max-w-[320px] hover:opacity-90 transition"
      >
        <img
          src={blobUrl}
          alt=""
          className="w-full h-auto max-h-[320px] object-cover"
          data-testid="msg-image"
        />
      </button>
      {expanded && (
        <div
          className="fixed inset-0 z-50 bg-black/85 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setExpanded(false)}
          data-testid="msg-image-lightbox"
        >
          <img
            src={blobUrl}
            alt=""
            className="max-w-full max-h-full rounded-xl shadow-2xl"
          />
        </div>
      )}
    </>
  );
}
